import { FC, useEffect } from 'react';

import FileInput from 'components/molecules/form/FileInput';
import { useFormEnvironment } from 'components/molecules/form/Form/formEnvironment';
import { useFormWatch } from 'components/molecules/form/Form/useFormWatch';

interface SubmitFileInputProps {
  onUploadFile: (file: File) => void;
}

const SubmitFileInput: FC<SubmitFileInputProps> = ({ onUploadFile }) => {
  const { resetField } = useFormEnvironment();

  const fileValue = useFormWatch<File>('file');

  useEffect(() => {
    if (fileValue === undefined) return;

    onUploadFile(fileValue);

    resetField('file', undefined);
  }, [fileValue, onUploadFile, resetField]);

  return <FileInput fieldName="file" label="File" />;
};

export default SubmitFileInput;
